import { useState, memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { Devices, WifiOff, Wifi, Assessment } from "@mui/icons-material";
import StatCard from "./StatCard";
import ChangeDeviceLimitDialog from "../Dialogs/ChangeDeviceLimitDialog";
import { CONFIG } from "../../config";

const DeviceStatsGrid = memo(({ devices, userDB, deviceStats }) => {
  const { t } = useTranslation("common");
  const [changeLimitDialogOpen, setChangeLimitDialogOpen] = useState(false);

  const handleChangeLimitClick = useCallback(() => {
    setChangeLimitDialogOpen(true);
  }, []);

  const handleChangeLimitClose = useCallback(() => {
    setChangeLimitDialogOpen(false);
  }, []);

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <StatCard
            title={t("common.devices")}
            value={deviceStats.total}
            loading={!devices}
            icon={<Devices />}
            color="primary"
            showLimit={!!userDB?.device_limit}
            limit={userDB?.device_limit}
            onLimitChange={
              userDB?.device_limit && CONFIG.billing_enabled
                ? handleChangeLimitClick
                : null
            }
            clickable={true}
            to="/device"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <StatCard
            title={t("common.online")}
            value={deviceStats.online}
            loading={!devices}
            icon={<Wifi />}
            color="success"
            clickable={true}
            to="/device?status=online"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <StatCard
            title={t("common.offline")}
            value={deviceStats.offline}
            loading={!devices}
            icon={<WifiOff />}
            color="error"
            clickable={true}
            to="/device?status=offline"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <StatCard
            title="Online %"
            value={`${deviceStats.onlinePercent}%`}
            loading={!devices}
            icon={<Assessment />}
            color="info"
            clickable={false}
          />
        </Grid>
      </Grid>

      <ChangeDeviceLimitDialog
        open={changeLimitDialogOpen}
        onClose={handleChangeLimitClose}
        currentLimit={userDB?.device_limit || 0}
        currentUsage={deviceStats.total}
        user={userDB}
      />
    </>
  );
});

DeviceStatsGrid.displayName = "DeviceStatsGrid";

export default DeviceStatsGrid;
